import { EBrowserStorageType } from '@/core/apis/browser_storage_api/browser_storage_api_types';
import { EDestinationType } from '@/core/interfaces';

import { StorageHandler } from '../storage_handler';
import {
  EConsentSource,
  EConsentValue,
  TConsentData,
  TConsentMap,
} from './types';

export class ConsentHandler {
  static getDestinationsConsentMap(): TConsentMap {
    return ConsentHandler.getConsent().consentMap;
  }
  private static readonly storageHandler = new StorageHandler<TConsentData>(
    'consentData',
    { consentMap: {}, source: EConsentSource.NONE },
    EBrowserStorageType.LOCALSTORAGE,
  );

  static setConsent(consentMap: TConsentMap, source: EConsentSource): void {
    // TODO: update session and perform identity if not on load?
    const currentData = ConsentHandler.storageHandler.get();
    const updatedData: TConsentData = {
      consentMap: { ...currentData?.consentMap, ...consentMap },
      source,
    };
    ConsentHandler.storageHandler.set(updatedData);
  }

  static getConsent(): TConsentData {
    return ConsentHandler.storageHandler.get();
  }

  static getConsentForDestination(
    destination: EDestinationType | 'all',
  ): EConsentValue {
    const { consentMap } = ConsentHandler.storageHandler.get();
    return consentMap
      ? consentMap[destination] || consentMap?.all || EConsentValue.NO_DECISION
      : EConsentValue.NO_DECISION;
  }
}
